import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Icon } from "@/components/Icon";
import { PageHero } from "@/components/PublicLayout";
import { CTABanner } from "@/components/CTABanner";

export default function ServiceAreas() {
  const [areas, setAreas] = useState([]);
  useEffect(() => { api.get("/service-areas").then((r) => setAreas(r.data)).catch(() => setAreas([])); }, []);

  return (
    <>
      <PageHero
        eyebrow="Service Areas"
        title="Proudly Serving Communities Across Pennsylvania"
        subtitle="CareDeserved provides non-emergency medical, wheelchair, and ambulatory transportation throughout counties in eastern and central Pennsylvania. Select a county to learn more."
      />
      <section className="bg-white py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {areas.map((a) => (
              <Link key={a.id} to={`/service-areas/${a.slug}`} data-testid={`area-${a.slug}`}
                className="group flex items-center justify-between rounded-2xl border border-slate-200 bg-brand-bg p-6 transition-all duration-300 hover:-translate-y-1 hover:border-brand-purple/30 hover:shadow-md">
                <div className="flex items-center gap-4">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-teal/10 text-brand-teal">
                    <Icon name="MapPinLine" size={24} weight="duotone" />
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-semibold text-slate-900">{a.county} County</h3>
                    <p className="text-sm text-slate-500">{a.state}</p>
                  </div>
                </div>
                <Icon name="ArrowRight" size={18} weight="bold" className="text-brand-purple transition-transform group-hover:translate-x-1" />
              </Link>
            ))}
          </div>
          <p className="mt-10 text-center text-sm text-slate-500">
            Don't see your county? <Link to="/contact" className="font-semibold text-brand-purple hover:underline">Contact us</Link> — we're always expanding.
          </p>
        </div>
      </section>
      <CTABanner />
    </>
  );
}
